<ng-template [ngIf]="isUploadingDoc">
  <app-loading></app-loading>
</ng-template>
   <div class="d-flex mt-2">
        <div class="grid formgrid p-fluid">
            
          <div class="field mt-2 mb-2 col-12">
            <p-fileUpload *ngIf="isTipoD" 
            multiple="true"
            maxFileSize="15000000"
            accept=".p7m"
            chooseLabel="Cerca" uploadLabel="Carica" cancelLabel="Cancella"
            [auto]="true"
            [customUpload]="true"
            (uploadHandler)="onFileUpload($event)"
            [showUploadButton]="false"
            [showCancelButton]="false"
            [disabled]="isFileUploaded"
            (onRemove)="onFileRemove()"
            >
          </p-fileUpload>
          <p-fileUpload *ngIf="!isTipoD" 
                mode="basic" 
                name="caricaFile"
                multiple="false"
                maxFileSize="5000000000"
                accept=".p7m"
                [auto]="false"
                chooseLabel="{{label}}"
                chooseIcon="{{icona}}"
                uploadIcon="{{icona}}"
                uploadLabel="{{label}}"
                [styleClass]="fileClass"
                (onUpload)="onFileUpload($event)" 
                (onSelect)="onFileSelect($event)" 
                url="https://www.primefaces.org/cdn/api/upload.php"
            >
          </p-fileUpload>
          <!-- <div *ngIf="displayFileName" class="mt-2 text-center">
            <span class="font-bold">{{displayFileName}}</span>
          </div> -->
      </div>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
      <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
      styleClass="p-button-warning"></p-button>
     <p-button  icon="pi pi-check" label="Conferma"
      class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isUploadingDoc || !areFileUploaded"></p-button>
  </div>
    <p-toast />
    <p-confirmDialog /> 